export type DiffLine = {
  lineNumber: number;
  type: "unchanged" | "added" | "removed";
  value: string;
};

export function diffLines(left: string, right: string): DiffLine[] {
  const leftLines = left.split(/\r?\n/);
  const rightLines = right.split(/\r?\n/);
  const maxLength = Math.max(leftLines.length, rightLines.length);
  const output: DiffLine[] = [];

  for (let index = 0; index < maxLength; index += 1) {
    const leftValue = leftLines[index];
    const rightValue = rightLines[index];

    if (leftValue === rightValue) {
      output.push({
        lineNumber: index + 1,
        type: "unchanged",
        value: leftValue ?? "",
      });
      continue;
    }

    if (leftValue !== undefined) {
      output.push({
        lineNumber: index + 1,
        type: "removed",
        value: leftValue,
      });
    }

    if (rightValue !== undefined) {
      output.push({
        lineNumber: index + 1,
        type: "added",
        value: rightValue,
      });
    }
  }

  return output;
}
